import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LogService } from '../../services/log.service';
import { UserSessionService } from '../../services/user-session.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string = '';
  password: string = '';
  loading: boolean = false;
  errorMessage: string = '';
  infoMessage: string = '';

  constructor(
    private auth: AuthService,
    private router: Router,
    private logService: LogService,
    private userSession: UserSessionService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const reason = this.route.snapshot.queryParamMap.get('reason');
    if (reason === 'expired') {
      this.infoMessage = 'Sua sessão expirou por inatividade. Faça login novamente.';
    } else if (reason === 'logout') {
      this.infoMessage = 'Você saiu do sistema com segurança.';
    } else {
      this.infoMessage = '';
    }
  }

  async login() {
    this.loading = true;
    this.errorMessage = '';
    this.infoMessage = '';

    const isDesktop = this.route.snapshot.queryParamMap.get('desktop') === '1';
    this.auth.login(this.email, this.password).subscribe({
      next: (res: any) => {
        localStorage.setItem('token', res.token);
        localStorage.setItem('last_activity_at', String(Date.now()));
        if (isDesktop) {
          const today = new Date().toISOString().slice(0, 10);
          localStorage.setItem('controlchat_desktop_last_login', today);
          localStorage.setItem('controlchat_desktop_mode', '1');
        } else {
          localStorage.removeItem('controlchat_desktop_last_login');
          localStorage.removeItem('controlchat_desktop_mode');
        }

        if (res.user) {
          this.userSession.setUser(res.user);
        }

        this.logService.register('LOGIN', 'Usuário logou no sistema').subscribe({
          error: (logErr) => console.error('Erro ao registrar log de login', logErr)
        });

        this.loading = false;
        this.router.navigate([isDesktop ? '/controlchat-desktop' : '/feed']);
      },
      error: (err) => {
        this.errorMessage = err.error?.error || "Erro ao fazer login.";
        this.loading = false;
      }
    });
  }

}
